import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AfsTableWrapper;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import t from '@instructure/quiz-i18n/format-message';
import { Heading } from '@instructure/ui-heading';
import { jsx } from '@instructure/emotion';
import generateStyle from './styles';
import PropTypes from 'prop-types';
import { noAnswerMissing } from './popoverContent';
import MetricPopover from '../../../MetricPopover';
import { Flex, withStyleOverrides } from '@instructure/quiz-common';
export var AfsTableWrapper = (_dec = withStyleOverrides(generateStyle, null), _dec(_class = (_AfsTableWrapper = /*#__PURE__*/function (_Component) {
  function AfsTableWrapper() {
    var _this2;
    _classCallCheck(this, AfsTableWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, AfsTableWrapper, [].concat(args));
    _defineProperty(_this2, "getHeader", function () {
      var tableHeader = _this2.props.tableHeader;
      return tableHeader || t('Answer Frequency Summary');
    });
    _defineProperty(_this2, "render", function () {
      var noAnswerMissingPopover = _this2.props.noAnswerMissingPopover;
      return jsx(Flex, {
        direction: "row",
        "data-testid": "AfsTableWrapper"
      }, jsx(Flex.Item, {
        shouldGrow: true
      }, jsx("div", {
        css: _this2.props.styles.tableWrapper
      }, jsx(Heading, {
        margin: "x-large x-large x-large 0",
        level: "h3",
        weight: "bold",
        color: "primary"
      }, jsx(Flex, {
        gap: "x-small"
      }, jsx(Flex.Item, null, _this2.getHeader()), jsx(Flex.Item, null, noAnswerMissingPopover && jsx(MetricPopover, noAnswerMissing)))), _this2.props.children)));
    });
    return _this2;
  }
  _inherits(AfsTableWrapper, _Component);
  return _createClass(AfsTableWrapper);
}(Component), _defineProperty(_AfsTableWrapper, "displayName", 'AfsTableWrapper'), _defineProperty(_AfsTableWrapper, "componentId", "Quizzes".concat(_AfsTableWrapper.displayName)), _defineProperty(_AfsTableWrapper, "propTypes", {
  children: PropTypes.node.isRequired,
  styles: PropTypes.object,
  tableHeader: PropTypes.string,
  noAnswerMissingPopover: PropTypes.bool
}), _AfsTableWrapper)) || _class);